import React from 'react';
import { Gauge } from '@ant-design/plots';
import { Props } from './types';

const DemoGauge: React.FC<Props> = ({ percent }) => {
  const porcentg = percent ?? 0;
  const config = {
    percent: porcentg,
    type: 'meter',
    meter: {
      steps: 50,
      stepRatio: 0.8,
    },
    innerRadius: 0.75,

    range: {
      ticks: [0, 0.6, 0.8, 1],
      color: ['#F4664A', '#FAAD14', '#30BF78'],
    },
    indicator: {
      pointer: {
        style: {
          stroke: '#D0D0D0',
          linewidth: 5,
          lineHight: 10,
        },
      },
      pin: {
        style: {
          stroke: '#D0D0D0',
        },
      },
    },
    axis: {
      label: {
        formatter(v: any) {
          return Number(v) * 100;
        },
        style: {
          fontSize: 20,
        },
      },

      subTickLine: {
        count: 0,
      },
    },

    statistic: {
      content: {
        formatter: ({ percent }: any) =>
          `<span class="themeDashboard">${(percent * 100).toFixed(0)}%</span>`,
        style: {
          color: 'rgba(0,0,0,0.65)',
          fontSize: '36px',
        },
      },
    },
  };
  return <Gauge {...config} />;
};

export default DemoGauge;
